import { useRef } from "react"

// Can be used for things like scroll events, when you only want
// something to fire once on scroll and then ignore any future events.
export default function useSingleFireEventHandler({
    handlerFunc,
}: {
    handlerFunc: () => void
}) {
    const hasFiredRef = useRef(false)

    return () => {
        if (hasFiredRef.current) return

        hasFiredRef.current = true
        handlerFunc()
    }
}
